/**
 * @generated SignedSource<<d84d1a3fe14d15b5d2fdfafe921f3d28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedExcellentValuesCarouselVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedExcellentValuesCarouselVariant_user";
};
export type HpSharedExcellentValuesCarouselVariant_user$key = {
  readonly " $data"?: HpSharedExcellentValuesCarouselVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedExcellentValuesCarouselVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedExcellentValuesCarouselVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c7ea14ede3ae737b6249ce8b5b6aecd5";

export default node;
